/* eslint-disable */
export const isString = (val: unknown): val is string => typeof val === 'string';
export const isNumber = (val: unknown): val is number => typeof val === 'number';
export const isBoolean = (val: unknown): val is boolean => typeof val === 'boolean';
export const isArray = (val: unknown): val is Array<unknown> => Array.isArray(val);
export const isObject = (val: unknown): val is object => typeof val === 'object' && val !== null && !Array.isArray(val);
export const isFunction = (val: unknown): val is Function => typeof val === 'function';
export const isUndefined = (val: unknown): val is undefined => typeof val === 'undefined';
export const isNull = (val: unknown): val is null => val === null;
